(function($) {
  $(function() {
    var $story = $('.student-profiles-row .story'),
        $storyOpen = $('.student-profiles-row .story > a.stage'),
        $storyClose = $('.student-profiles-row .story-details > a.toggle');

    $storyOpen.on('click.storyOpen', function(e){
      e.preventDefault();
      $story.removeClass('opened');
      $(this).parent('.story').addClass('opened');
    });

    $storyClose.on('click.storyOpen', function(e){
      e.preventDefault();
      $(this).closest('.story').removeClass('opened');
    });
  });
})($JQ);
